const StepForm = function (props) {
    return(
        <React.Fragment>
        <div className="row no-gutters">
             {(props.data.ModQuestIconClass) &&
                <i className={props.data.ModQuestIconClass} aria-hidden="true"></i>
             }
            <div className="modalSubject">{props.data.Title}</div>
             
        </div>
        <div className="stepMoreeText" dangerouslySetInnerHTML={{__html: props.data.MODQuestText}}></div>
        </React.Fragment>
    )
}
export default StepForm;